<script>
import MonitoringReport from '@/views/pages/monitoring-report/MonitoringReport.vue'

export default {
  name: 'MonitoringReportDoc',
  components: { MonitoringReport },
}
</script>

<template>
  <monitoring-report type="monitoringReportDoctorateList" />
</template>

<style scoped>

</style>
